import actions from './actions'
import type { TaxationDetailsReducerAction } from './types'

export const initialState: TaxationDetailsStore = {
  data: null,
  loading: false,
  fetched: false,
  error: null,
}

export default function reducer(
  state: TaxationDetailsStore = initialState,
  action: TaxationDetailsReducerAction
): TaxationDetailsStore {
  switch (action.type) {
    case actions.fetchCompanyTaxationDetails.REQUEST:
      return {
        ...state,
        loading: true,
        fetched: false,
        error: null,
      }

    case actions.fetchCompanyTaxationDetails.SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        fetched: true,
        error: null,
      }

    case actions.fetchCompanyTaxationDetails.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}
